<template>
  <div class="table-placeholder"
       :class="`table-placeholder--gutter-${gutterSize} ${darker ? 'table-placeholder--darker' : ''}`">
    <div v-for="index in Number(rowCount)" :key="index"
         class="table-placeholder__row"
         :style="`height: ${rowHeight}px`">
    </div>
  </div>
</template>

<script>
export default {
  name: 'TableLoadingPlaceholder',
  props: {
    rowCount: {
      type: [Number, String],
      required: false,
      default: 3,
    },
    rowHeight: {
      type: String,
      required: false,
      default: '60',
    },
    gutterSize: {
      type: String,
      required: false,
      default: '5',
    },
    darker: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
}
</script>
